/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import ContextConstructor from "../../components/Context/Context";
import sendLogError from "../../sendLogError";
import AreaCard from "../../components/AreaCard/AreaCard";
import ButtonNavContainer from "../../components/ButtonNavContainer/ButtonNavContainer";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import MemberCard from "../../components/MemberCard/MemberCard";
import { AuthContext } from "../../AuthProvider";
import { ProfileMenu } from "../../utils/ProfileMenu";

import DataCard from "../../components/DataCard/DataCard";

import { getLOGOUT, getPasswordChange } from "../../env";

/* MODULE IMPORTS */
import React, { Component } from "react";

/* CSS IMPORT */
import "./Profile.css";
import loadingImg from "../../images/loading.svg";
import { ArrowLeft } from "lucide-react";
import formatDatePT from "../../utils/formatDatePT";
import { handleChannelBack } from "../../utils/handleChannelBack";

var reactPlugin = new ReactPlugin();

class Profile extends Component {
  static displayName = Profile.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      profile: [],
      error: [],
      loading: true,
      choice: ProfileMenu.MENU,
    };
  }

  componentDidMount() {
    this.populateProfileData();
  }

  handleBack = () => {
    handleChannelBack({
      isMobileAuth: this.context.isMobileAuth,
      onWebBack: () => this.props.history.goBack(),
    });
  };

  logout() {
    window.sessionStorage.setItem("showedElectionPopup", "false");

    const { msalInstance } = this.context;
    if (msalInstance) {
      msalInstance.logoutRedirect({
        postLogoutRedirectUri: getLOGOUT(),
        idTokenHint: this.context.idToken,
      });
    }
  }

  // changePassword() {
  //   const { msalInstance } = this.context;
  //   msalInstance.loginRedirect({
  //     authority: getPasswordChange(),
  //   });
  // }

  changePassword() {
    const { msalInstance } = this.context;

    const authority = getPasswordChange();

    console.log("Password reset authority:", authority);

    msalInstance.loginRedirect({
      authority,
      redirectUri: this.state.redirectUri,
    });
  }

  static errorLoadingPortfolio() {
    return (
      <div>
        <ErrorPage />
      </div>
    );
  }

  buildMenu(profile) {
    console.log("MENU");
    return (
      <div className="main-profile">
        <div className="profile-title">
          <ArrowLeft
            className="profile-title-back"
            onClick={() => {
              this.handleBack();
            }}
          />
          Perfil
        </div>
        <div class="parent">
          <div class="div1">
            <MemberCard
              name={profile.name}
              joinDate={formatDatePT(profile.associateAdmissionDate)}
              cardNumber={profile.associateID}
            />
          </div>
          <div class="div2">
            <AreaCard onClick={this.buttonAreaCardClickItem} />
          </div>
          <div class="div3">
            <ButtonNavContainer onClick={this.buttonNavContainerClickItem} />
            <ActionButtons
              onPasswordClick={() => {
                this.changePassword();
              }}
              onLogoutClick={() => {
                this.logout();
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  buttonNavContainerClickItem = (item) => {
    this.setState({ choice: item });
  };

  buttonAreaCardClickItem = (item) => {
    this.setState({ choice: item });
  };

  buildMyData(profile) {
    return (
      <div className="main-profile">
        <div className="profile-title">
          <ArrowLeft
            className="profile-title-back"
            onClick={() => {
              this.setState({ choice: ProfileMenu.MENU });
            }}
          />
          Os meus dados
        </div>
        <div class="parent-mydata">
          <div class="div1-mydata">
            <MemberCard
              name={profile.name}
              joinDate="15/05/2023"
              cardNumber={profile.associateID}
            />
          </div>
          <div class="div2-mydata">
            <DataCard
              title_card="Contactos"
              title_1="Telemóvel"
              value_1={profile.telephone}
              title_3="Email"
              value_3={profile.email}
            />
          </div>
          <div class="div3-mydata">
            <DataCard
              title_card="Morada"
              title_1="Morada"
              value_1={profile.address}
              title_3="Localidade"
              value_3={profile.locality}
              title_4="Código Postal"
              value_4={profile.postalCode}
            />
          </div>
          <div class="div4-mydata">
            <DataCard
              title_card="Outros dados"
              title_1="NIF"
              value_1={profile.nif}
              title_2="IBAN"
              value_2={profile.iban}
              title_3="N.º de Associado"
              value_3={profile.associateID}
            />
          </div>
        </div>
      </div>
    );
  }

  renderProfileData(profile) {
    let content;
    switch (this.state.choice) {
      case ProfileMenu.MENU:
        content = this.buildMenu(profile);
        break;
      case ProfileMenu.MY_DATA:
        content = this.buildMyData(profile);
        break;
      default:
        content = this.buildMenu(profile);
    }
    return content;
  }

  render() {
    let contents = this.state.loading ? (
      <div className="main-page-loading">
        <div className="loading">
          <img src={loadingImg} alt="carregamento"></img>
        </div>
      </div>
    ) : this.state.error ? (
      Profile.errorLoadingPortfolio()
    ) : (
      this.renderProfileData(this.state.profile)
    );

    return <div>{contents}</div>;
  }

  async populateProfileData() {
    try {
      const { idToken } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
      };

      const response = await fetch("/Profile/GetProfile", { headers });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      this.setState({
        error: false,
        profile: data,
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching profile:", error);

      this.setState({
        error: true,
        loading: false,
      });

      sendLogError(error.message, "populateProfileData");
    }
  }
}

Profile.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Profile);
